import { useQuery } from "@tanstack/react-query";
import { PackageType } from "models/packages";
import { useAuthenticatedRequest } from "./useRequests";

/**
 * Based on the role of the authenticated user, returns all enabled package types (staff/admin), 
 * or just package types that apply to the customer (user)
 */
const useAvailablePackageTypes = (withFees: boolean = false, includePackageTypeId?: string) => {
    const getTypes = useAuthenticatedRequest<PackageType[]>({
        url: `/package-types/available?withFees=${withFees}&includeTypeId=${(includePackageTypeId ?? '')}`,
        method: "GET",
    });

    return useQuery(["package-types", "available", withFees, includePackageTypeId], getTypes);
};

export default useAvailablePackageTypes;